// extracted by mini-css-extract-plugin
export var btn = "style-module--btn--43918";
export var icon = "style-module--icon--b4e53";
export var result = "style-module--result--b265f";